
<script setup lang="js">
/*
	Modal wrapper for the BasicTableViewer.vue component.
	Data: Array of objects with the data for each row.
	Columns: Array of objects that defines the columns and their headings.
						Order in object is order displayed. If not defined, objects shown with keys
						as columns and all data is shown.
 */

import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import BaseModal from '@/components/Alerts/BaseModal.vue'
import { ButtonSize, ButtonType } from '@/components/Forms/Buttons/SubmitButtonConstants.js'
import { useClipboard } from '@vueuse/core'
import { Toaster } from '@/models/utils/Toaster.js'
import BasicTableViewer from '@/components/Alerts/BasicTableViewer.vue'

const props = defineProps({
	show: { type: Boolean, default: false },
	title: { type: String, default: '' },
	data: {
		type: [Object, null],
		required: true,
		default: null
	},
	/**
	 * Set keys if there are values to ignore
	 * Array of { "key": string, "title": string, "width": string,
	 *            "type": "date", "date_format": Object }
	 * "type" and "date_format" are optional; "type": "date" forces date formatting for the
	 * column instead of relying on value-shape detection. "date_format" is an
	 * Intl.DateTimeFormat options object passed straight to Format.date.
	 */
	columns: {
		type: Array,
		default: () => []
	}
})
const toaster = new Toaster();
const emit = defineEmits(['close']);

function copyText()
{
	useClipboard({ legacy: true }).copy(JSON.stringify(props.data, null, 2))

	toaster.success("Copied!")
}
</script>

<template>
	<BaseModal :show="show">
		<form class="flex flex-col max-h-[calc(100vh_-_8.125rem)] max-w-[calc(100vw_-_8.125rem)]">
			<div class="flex items-center space-x-2">
				<p class="text-xl font-bold text-heading">{{ props.title }}</p>
			</div>

			<BasicTableViewer
				:data="props.data"
				:columns="props.columns"
				:modal="true"
				class="w-full"></BasicTableViewer>
			<div class="flex flex-row mt-5 ml-auto space-x-4">
				<SubmitButton label="Copy Data" :type="ButtonType.Outline" :size="ButtonSize.Small" @click.prevent="copyText()" />
				<SubmitButton label="Ok" :type="ButtonType.Default" :size="ButtonSize.Small" @click.prevent="emit('close')" />
			</div>
		</form>
	</BaseModal>
</template>